import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0
  })
}

export { Sentry }
